export default {
    'lang': {
        'en': "English",
        'ja': "Japanese"
    },
    'button': {
        'login': "ログイン",
        'signUp': "無料会員登録はこちら",
        'next': '次へ',
        'forgotPassword': 'パスワードを忘れた方はこちら',
        'resetPasswordSuccess': 'ログイン画面に戻る',
        'changePassword': '確認',
        'send': '送信',
        'goHome': 'トップへ',
        'addNewBaby': '追加',
        'addNewBabyFull': 'お子様追加',
        'close': '閉じる',
        'nextQuestion': '次へ',
        'finish': '完了',
        'back': '戻る',
        'changeUserInformation': '会員情報の変更',
        'save': '変更内容を反映',
        'recordingGrowth': 'さぁ成長の記録をはじめよう！'
    },
    'label': {
        'search': 'Search',
        'uploadImage': '達成記念の写真を投稿しよう！',
        'setting': '設定',
        'changeUserInfo': '会員情報の変更',
        'addNewBaby': 'お子様追加',
        'searchResult': '検索結果',
        'question': '質問',
        'person': 'ちゃん',
        'detailBaby': '人目お子様の情報',
        'error404': 'ページが見つかりません',
        'error505En': 'Internal Server Error',
        'error505Jp': 'アクセスしようとした\n' +
            'ページは表示できませんでした',
        'backToHome': 'TOPに戻る'
    },
    'input': {
        'placeholder': {
            'babyName': 'お子様の名前',
            'birthDay': 'お子様の生年月日',
            'email': 'メールアドレス',
            'password': 'パスワード',
            'newPassword': "新しいパスワード",
            'confirmNewPassword': "確認用パスワード",
            'search': "フリーワード検索",
            'forgotPassword': '登録したメールアドレスを入力して送信ボタンをタップしてください。\n' +
              'パスワード変更メールが届きます。',
            'currentPassword': '現在のパスワード',
        }
    },
    'checkbox': {
        'keepLogin': 'ログインのままにする'
    },
    'pagination': {
        'next': "Next",
        'prev': "Previous"
    }
};
